/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
export const getProjectsNavigationPaths = (): {
	projectsViewProjects: string;
	projectsViewCategories: string;
	projectsPolicies: string;
	projectsTrashedProjects: string;
	projectsArchivedProjects: string;
} => ({
	projectsViewProjects: '/jira/settings/projects/manage',
	projectsViewCategories: '/secure/admin/projectcategories/ViewProjectCategories!default.jspa',
	projectsPolicies: '/jira/settings/projects/policies',
	projectsTrashedProjects: '/jira/settings/projects/trash',
	projectsArchivedProjects: '/jira/settings/projects/archive',
});
